import { render, staticRenderFns } from "./AddUserMachineLabels.vue?vue&type=template&id=5b0d70d3&scoped=true"
import script from "./AddUserMachineLabels.vue?vue&type=script&lang=js"
export * from "./AddUserMachineLabels.vue?vue&type=script&lang=js"
import style0 from "./AddUserMachineLabels.vue?vue&type=style&index=0&id=5b0d70d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d70d3",
  null
  
)

export default component.exports